import { ShippingOptionType } from '../bff-api/baskets/model';
import type { ProductItem } from '../bff-api/baskets/model';

export const getShippingOptionType = ({
    c_isSameDayDelivery,
    c_storepickupenabled,
}: ProductItem): ShippingOptionType => {
    if (c_isSameDayDelivery) {
        return ShippingOptionType.SDD;
    }

    if (c_storepickupenabled) {
        return ShippingOptionType.BOPIS;
    }

    return ShippingOptionType.SHIP_TO;
};
